import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import appRouteArticles from "@/util/app-route-articles.mjs";
import { devError } from "@/util/dev.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const fetchProfile = lazyFn(
  () => import("@/game-eft/fetches/profile-page.mjs"),
);
const fetchInGame = lazyFn(() => import("@/game-eft/fetches/in-game-page.mjs"));
const fetchMatch = lazyFn(() => import("@/game-eft/fetches/match-page.mjs"));
const fetchLeaderboards = lazyFn(
  () => import("@/game-eft/fetches/leaderboards-page.mjs"),
);
const fetchFleaMarket = lazyFn(
  () => import("@/game-eft/fetches/flea-market.mjs"),
);
const fetchFleaItem = lazyFn(() => import("@/game-eft/fetches/flea-item.mjs"));

const fetchMapData = lazyFn(() => import("@/game-eft/fetches/maps.mjs"));

const routes = [
  {
    path: pathRegExp("/eft/profile/:profileId{/:tab}?"),
    component: "game-eft/Profile.tsx",
    fetchData: fetchProfile,
  },
  {
    path: pathRegExp("/eft/in-game"),
    component: "game-eft/InGame.tsx",
    fetchData: fetchInGame,
  },
  {
    path: pathRegExp("/eft/match/:accountId/:gameId"),
    component: "game-eft/Match.tsx",
    fetchData: fetchMatch,
  },
  {
    path: pathRegExp("/eft/stats/:tab(weapons|maps)"),
    component: "game-eft/Stats.tsx",
    fetchData: fetchLeaderboards,
  },
  {
    path: "/eft/stats",
    redirect: "/eft/stats/weapons",
  },
  {
    path: pathRegExp("/eft/leaderboards/:tab(players)"),
    component: "game-eft/Leaderboards.tsx",
    fetchData: fetchLeaderboards,
  },
  {
    path: "/eft/leaderboards",
    redirect: "/eft/leaderboards/players",
  },
  {
    path: pathRegExp("/eft/database"),
    component: "game-eft/Database.tsx",
  },
  {
    path: pathRegExp("/eft/flea-market{/:category}?"),
    component: "game-eft/FleaMarket.tsx",
    fetchData: fetchFleaMarket,
  },
  {
    path: pathRegExp("/eft/flea-market/details/:itemSlug"),
    component: "game-eft/FleaItemDetails.tsx",
    fetchData: fetchFleaItem,
  },
  {
    path: pathRegExp("/eft/tier-list"),
    component: "game-eft/TierList.tsx",
  },
  {
    path: pathRegExp("/eft/launch"),
    component: "game-eft/Launch.tsx",
  },
  {
    path: pathRegExp("/eft/maps"),
    component: "game-eft/Maps.tsx",
    fetchData: fetchMapData,
  },
  {
    path: pathRegExp("/eft/maps/:tab"),
    redirect: "/eft/maps",
  },
  {
    path: "/eft/map",
    redirect: "/eft/maps",
  },
  ...appRouteArticles("eft"),
] as BaseRoute[];

routes.push({
  [catchAllRoutes]: routes,
  async fetchData() {
    try {
      const { fetchStatic } = await import("@/game-eft/fetches/static.mjs");
      await fetchStatic({ isLoadAsync: true });
    } catch (e) {
      devError("Failed to fetch EFT static data", e);
    }
  },
});

export default routes;
